import 'custom-event-polyfill';
import AdvancedDestinationSelector from './destinations/advanced-destination-selector';
import AdvancedDestinationSelectorV2 from './destinations/advanced-destination-selector-v2';
import AdvancedDestinationSelectorV3 from './destinations/advanced-destination-selector-v3';
import CompaniesMain from './companies/companies-main';
import EngineWidgetFormModifier from './engine-widget-form-modifier';
import OccupancyMain from './occupancy/occupancy-main';

const setFormatDates = (spanDay, spanMonth, elementDate) => {
    const day = spanDay.innerHTML.replace(/\n\s+/g, ''),
        month = spanMonth.innerHTML.replace(/\n\s+/g, ''),
        { dateFormat } = elementDate,
        { dateDisplay } = elementDate;

    if (dateFormat === 'usa') {
        if (dateDisplay === 'number') {
            spanDay.innerHTML = month.substring(0, 3);
            spanMonth.innerHTML = day.substring(0, 3) + month.substring(3);
        } else {
            spanDay.innerHTML = month.substring(0, month.indexOf(' '));
            spanMonth.innerHTML = `${day.substring(0, 2)} ${month.substring(month.indexOf(' '))}`;
        }
    } else if (dateFormat === 'zh') {
        if (dateDisplay === 'number') {
            spanDay.innerHTML = month.substring(3);
            spanMonth.innerHTML = `${month.substring(0, 2)}/${day.substring(0, 2)}`;
        } else {
            spanDay.innerHTML = month.substring(month.indexOf(' '));
            spanMonth.innerHTML = `${month.substring(0, month.indexOf(' '))} ${day}`;
        }
    }
};

function getDateDisplayValues({ dateFormat, dateDisplay }, date) {
    const day = String(date.getDate()).padStart(2, '0'),
        month = String(date.getMonth() + 1).padStart(2, '0'),
        year = date.getFullYear().toString(),
        shortMonthName = date.toLocaleString('default', { month: 'short' }),
        longMonthName = date.toLocaleString('default', { month: 'long' }),
        format = ['usa', 'zh'].includes(dateFormat) ? dateFormat : 'default',
        display = ['number', 'long'].includes(dateDisplay) ? dateDisplay : 'short',
        valuesByDisplay = {
            number: {
                default: [`${day}/`, `${month}/${year}`],
                usa: [`${month}/`, `${day}/${year}`],
                zh: [year, `${month}/${day}`]
            },
            long: {
                default: [day, `${longMonthName} ${year}`],
                usa: [longMonthName, `${day} ${year}`],
                zh: [year, `${longMonthName} ${day}`]
            },
            short: {
                default: [day, `${shortMonthName} ${year}`],
                usa: [shortMonthName, `${day} ${year}`],
                zh: [year, `${shortMonthName} ${day}`]
            }
        };

    return valuesByDisplay[display][format];
}

/* global RoiCalendar */
export default class EngineWidget {
    constructor (form, params = {}) {
        this._advancedDestinationTriggerSelector = '.js-roi-search-engine-destination-trigger';
        this._customDestinationListSelector = '.roi-search-engine__hotel-list';
        this._customDestinationLinkSelector = 'roi-search-engine__hotel-link';
        this._buttonSubmitFormSelector = '.roi-search-engine__field';
        this._modalNoDestinySelector = '.roi-search-engine__hotel-modal';
        this._modalNoDestinInnerSelector = '.roi-search-engine__hotel-inner';
        this._destinationCodeSelector = '.js-roi-search-engine-destination-code';
        this._destinationCode = null;
        this._destinationNameSelector = '.js-roi-search-engine-destination-name';
        this._currentDateValueInput = 'js-roicalendar-checkin-full-date';
        this._depatureDateValueInput = 'js-roicalendar-checkout-full-date';
        this._spanDayIn = 'js-roicalendar-checkin-day';
        this._spanMonthIn = 'js-roicalendar-checkin-month';
        this._spanDayOut = 'js-roicalendar-checkout-day';
        this._spanMonthOut = 'js-roicalendar-checkout-month';
        this._destinationName = null;
        this._form = null;
        this._formTemplate = null;
        this._isCorporate = null;
        this._asModal = !!params.asModal;
        this._init(form, params);
        this._submitInIframe();
    }

    getFormTemplate () { return this._formTemplate.cloneNode(true); }

    getHotelNameField (form) {
        const field = form.querySelector(this._advancedDestinationTriggerSelector);
        if (field === null) {
            return form.querySelector(this._destinationNameSelector);
        }
        return field;
    }

    formatToLangDates() {
        const engineItemDates = document.querySelectorAll('.roi-search-engine__item--dates'),
            contentDate = (engineItemDates.length > 1) ? engineItemDates[1] : engineItemDates[0];

        if (contentDate.dataset.dateFormat !== 'default') {
            setFormatDates(
                contentDate.getElementsByClassName(this._spanDayIn)[0],
                contentDate.getElementsByClassName(this._spanMonthIn)[0],
                contentDate.dataset
            );

            setFormatDates(
                contentDate.getElementsByClassName(this._spanDayOut)[0],
                contentDate.getElementsByClassName(this._spanMonthOut)[0],
                contentDate.dataset
            );
        }
    }

    _init (form, params) {
        form = form || document.querySelector('#roi-engine-form');
        this._dataMinDatesHotelCodes = JSON.parse(form.getAttribute('data-min-date-hotel-codes'));
        this._dataDatesOfferFrom = params.datesOfferFrom ? JSON.parse(params.datesOfferFrom) : null;
        this._offerCode = params.offerCode;
        this._minDate = params.minDate;
        this._dataMinNoches = params.dataMinNoches || form.getAttribute('data-minimo-noches');
        this._dataTradNoDestination = form.getAttribute('data-trad-no-destination');
        this._formTemplate = form.cloneNode(true); // Clone the form before manipulating it
        this._form = new EngineWidgetFormModifier(this).getPreparedForm(form, params);
        this._destinationName = this._form.querySelector(this._destinationNameSelector);
        this._destinationCode = this._form.querySelector(this._destinationCodeSelector);
        this._customDestinationList = this._form.querySelector(this._customDestinationListSelector);
        this._buttonSubmitForm = this._form.querySelector(this._buttonSubmitFormSelector);
        this._modalNoDestiny = this._form.querySelector(this._modalNoDestinySelector);
        this._isCorporate = this._destinationCode !== null;
        const interval = setInterval(() => {
            // Poll to check if RoiCalendar has been loaded. This strategy is
            // used instead of waiting for DOM events in order to avoid to keep
            // waiting for external content to be loaded
            if (window.RoiCalendar !== undefined) {
                clearInterval(interval);
                this._launch();
            }
        }, 200);
        this.constructor._checkPromoCode();
        if (this._destinationName && this._customDestinationList) {
            this._initializeCustomSelector();
        }
    }

    _initializeCustomSelector() {
        if (this._destinationCode.value) {
            const cachedDestiny = this._form.querySelector(`a[data-code="${this._destinationCode.value}"]`),
                cachedDestinyName = cachedDestiny.getAttribute('data-name');
            this._destinationName.value = cachedDestinyName;
        }
        this._customDestinationList = this._form.querySelector(this._customDestinationListSelector);
        this._destinationName.addEventListener('click', () => {
            const displayValue = this._customDestinationList.style.display;

            if (!displayValue || displayValue === 'none') {
                this._customDestinationList.style.display = 'block';
            } else {
                this._customDestinationList.style.display = 'none';
            }
        });
        this._customDestinationList.addEventListener('click', (param) => {
            const targetElement = param.target,
                code = targetElement.getAttribute('data-code'),
                name = targetElement.getAttribute('data-name'),
                dateMinHotelCode = this._dataMinDatesHotelCodes[code];

            if (dateMinHotelCode) {
                this._checkDatesDestinationCode(dateMinHotelCode, false);
            }
            this._destinationCode.value = code;
            this._destinationName.value = name;
            this._destinationName.click();
            this._destinationCode.dispatchEvent(new CustomEvent('input', {
                bubbles: true,
                cancelable: true
            }));
        });
        document.addEventListener('click', (event) => {
            if (
                !event.target.matches(this._modalNoDestinInnerSelector) &&
               this._modalNoDestiny.style.display !== 'none') {
                this._modalNoDestiny.style.display = 'none';
            }
        });
    }

    static _checkPromoCode () {
        const checkCodPromo = document.querySelector('.roi-search-engine__item--suggested-promocode'),
            codPromoInput = document.querySelector('.js-roi-search-engine-promo'),
            checkCodPromoInput = document.querySelector('.roi-search-engine__field--suggested-promocode');
        if (checkCodPromo) {
            if (codPromoInput.value && codPromoInput.value === checkCodPromoInput.dataset.promocode) {
                checkCodPromoInput.checked = true;
            }
            checkCodPromoInput.addEventListener('change', (event) => {
                if (event.target.checked) {
                    codPromoInput.value = event.target.dataset.promocode;
                } else {
                    codPromoInput.value = '';
                }
            });
        }
    }

    _keepFocusInForm () {
        if (!this._asModal) {
            return;
        }
        const lastFormElement = this._form.querySelector('button[type=submit]');
        let firstFormElement;
        if (this._isCorporate) {
            firstFormElement = this.getHotelNameField(this._form);
        } else {
            firstFormElement = this._form.querySelector('.js-roicalendar-trigger');
        }
        if (firstFormElement) {
            firstFormElement.addEventListener('keydown', (event) => {
                if (event.key === 'Tab' && event.shiftKey) {
                    event.preventDefault();
                    lastFormElement.focus();
                }
            });
        }
        lastFormElement.addEventListener('keydown', (event) => {
            if (event.key === 'Tab' && !event.shiftKey) {
                event.preventDefault();
                firstFormElement.focus();
            }
        });
    }

    _launch () {
        RoiCalendar.getInstance(
            this._form.dataset.lang,
            this._form.dataset.accessible === 'true',
            this._dataMinNoches,
        );
        new CompaniesMain(this._form);
        new OccupancyMain(this._form, this._isCorporate);
        try {
            const isAdvancedDestinationV2 = !!this._form.querySelector('.js-roi-search-engine-advanced-destination-v2'),
                isAdvancedDestinationV3 = !!this._form.querySelector('.js-roi-search-engine-advanced-destination-v3');

            if (isAdvancedDestinationV2) {
                new AdvancedDestinationSelectorV2(this._form, this._destinationCode);
            } else if (isAdvancedDestinationV3) {
                new AdvancedDestinationSelectorV3(this._form, this._destinationCode);
            } else {
                new AdvancedDestinationSelector(this._form, this._destinationCode);
            }
        } catch (e) {
            this._selectDestinationCode();
        }
        this._showFormAndHideLoadingSpinner();
        this._keepFocusInForm();

        if (+this._form.dataset.roiEngineWidgetIndex === 0) {
            document.body.dispatchEvent(new CustomEvent('RoiEngineReady', { bubbles: true }));
        }
    }

    _selectDestinationCode () {
        if (!this._isCorporate) { return; }
        if (this._minDate) { this._checkDatesDestinationCode(this._minDate, true); }

        if (this._destinationName) {
            this._destinationName.addEventListener('change', (event) => {
                const select = event.currentTarget;
                this._destinationCode.value = select.options[select.selectedIndex].dataset.value;

                const dateMinHotelCode = this._dataMinDatesHotelCodes[this._destinationCode.value];

                if (this._dataDatesOfferFrom && this._offerCode) {
                    if (this._dataDatesOfferFrom.hasOwnProperty(this._destinationCode.value)) {
                        this._checkDatesDestinationCode(
                            this._dataDatesOfferFrom[
                                this._destinationCode.value
                            ][this._offerCode].formato1, true
                        );
                    }
                }
                if (dateMinHotelCode) {
                    this._checkDatesDestinationCode(
                        dateMinHotelCode, false
                    );
                }
                this._destinationCode.dispatchEvent(new CustomEvent('input', {
                    bubbles: true, cancelable: true
                }));
            });
        }
    }

    _checkDatesDestinationCode (date, offer) {
        date = (date && date.includes(':')) ? date : `${date}T00:00:00`;
        const todayDate = new Date(),
            selectedDate = new Date(date),
            compareDates = (selectedDate > todayDate);
        if (compareDates) {
            this._setDates(selectedDate, offer);
        } else { this._setDates(todayDate, offer); }
    }

    static _getFormattedDate (date) {
        const year = date.getFullYear(),
            month = String(date.getMonth() + 1).padStart(2, '0'),
            day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    _setDates (dateIn, offer) {
        let dateOut = new Date(dateIn);
        dateOut.setDate(dateOut.getDate() + Number(this._dataMinNoches));
        this.constructor._drawDates(
            document.getElementsByClassName(this._spanDayIn)[offer ? 1 : 0],
            document.getElementsByClassName(this._spanMonthIn)[offer ? 1 : 0],
            dateIn
        );
        this.constructor._drawDates(
            document.getElementsByClassName(this._spanDayOut)[offer ? 1 : 0],
            document.getElementsByClassName(this._spanMonthOut)[offer ? 1 : 0],
            dateOut
        );
        dateIn = this.constructor._getFormattedDate(dateIn);
        dateOut = this.constructor._getFormattedDate(dateOut);
        document.getElementsByClassName(
            this._currentDateValueInput
        )[offer ? 1 : 0].value = this.constructor._formatDate(dateIn);
        document.getElementsByClassName(
            this._depatureDateValueInput
        )[offer ? 1 : 0].value = this.constructor._formatDate(dateOut);
    }

    static _drawDates (spanDay, spanMonth, date) {
        const dateItem = spanDay.closest('.roi-search-engine__item--dates'),
            dateSettings = dateItem ? dateItem.dataset : {},
            [dayValue, monthValue] = getDateDisplayValues(dateSettings, date);
        spanDay.innerHTML = dayValue;
        spanMonth.innerHTML = monthValue;
    }

    static _formatDate (input) {
        if (['', undefined].includes(input)) { return undefined; }
        return input.split('-').reverse().join('/');
    }

    _showFormAndHideLoadingSpinner () {
        // Make sure the customization styles are the last element in
        // the head so that they have precedence
        const { head } = document,
            link = Array.from(head.querySelectorAll('link'))
                .filter(item => item.getAttribute('rel') === 'stylesheet')
                .slice(-1)[0];
        if (window.location.pathname.split('/').includes('admin')) {
            head.appendChild(
                head.removeChild(head.querySelector('#roi-search-engine-styles'))
            );
        } else {
            head.insertBefore(head.querySelector('#roi-search-engine-styles'), link);
        }
        const loadingContainer = document.querySelector('#roi-engine-loading');
        if (loadingContainer !== null) {
            loadingContainer.parentNode.removeChild(loadingContainer);
        }
        this._form.style.removeProperty('display');
    }

    _getUtagDates(dateClass) { // eslint-disable-line
        const date = document.getElementsByClassName(
                dateClass
            )[0].value,
            dateArr = date.split('/'),
            dateStr = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;

        return dateStr;
    }

    _getUtagOccupancies() { // eslint-disable-line
        const occupancies = document.getElementsByClassName(
                'js-roi-search-engine-occupancies-values'
            )[0].value,
            parsedOccupancies = JSON.parse(occupancies),
            numberRooms = parsedOccupancies.length;
        let totalAdults = 0,
            totalChildren = 0;
        for (let i = 0; i < parsedOccupancies.length; i++) {
            totalAdults += parseInt(parsedOccupancies[i].adults, 10);
            totalChildren += parseInt(parsedOccupancies[i].children, 10);
        }
        const totalTravelers = totalAdults + totalChildren;
        return [
            totalAdults.toString(),
            totalChildren.toString(),
            totalTravelers.toString(),
            numberRooms.toString()
        ];
    }

    _getNights(checkin, checkout) { // eslint-disable-line
        checkin = checkin.split('-');
        checkout = checkout.split('-');

        const checkinDate = new Date(checkin[0], checkin[1] - 1, checkin[2]),
            checkoutDate = new Date(checkout[0], checkout[1] - 1, checkout[2]),

            timeDifference = Math.abs(checkoutDate.getTime() - checkinDate.getTime()),
            numberOfNights = Math.ceil(timeDifference / (1000 * 3600 * 24));
        return numberOfNights;
    }

    _getFormattedCurrentDate() { // eslint-disable-line
        const currentDate = new Date(),
            month = (currentDate.getMonth() + 1).toString().padStart(2, '0'),
            day = currentDate.getDate().toString().padStart(2, '0'),
            year = currentDate.getFullYear().toString();
        return `${month}-${day}-${year}`;
    }

    _getBookingWindow(chekin){ // eslint-disable-line
        const currentDate = new Date(),
            checkinArray = chekin.split('-'),
            checkinDate = new Date(checkinArray[0], checkinArray[1] - 1, checkinArray[2]),
            timeDifference = Math.abs(checkinDate.getTime() - currentDate.getTime()),
            bookingWindow = Math.ceil(timeDifference / (1000 * 3600 * 24));

        return bookingWindow;
    }

    _getInpputValueById(inputId){ // eslint-disable-line
        const input = document.getElementById(inputId);

        if (input && input.value) {
            return input.value;
        }
        return '';
    }

    _utagSubmitEvent() {
        const checkin = this._getUtagDates(this._currentDateValueInput),
            checkout = this._getUtagDates(this._depatureDateValueInput),
            [totalAdults, totalChildren, totalTravelers, numberRooms] = this._getUtagOccupancies(),
            numberOfNights = this._getNights(checkin, checkout),
            currentDate = this._getFormattedCurrentDate(),
            codpromo = this._getInpputValueById('id_codpromo-widget-0'),
            bookingWindow = this._getBookingWindow(checkin),
            corporateGroupNumber = this._getInpputValueById('loyalty-id-widget-0');
        utag.link({ // eslint-disable-line
            date_checkin: checkin, // check in date in YYYY-MM-DD format
            date_checkout: checkout, // check out date in YYYY-MM-DD format
            number_of_adults: totalAdults, // Number of adults selected
            number_of_children: totalChildren, // Number of children selected
            number_of_travellers: totalTravelers, // Total number of travellers selected
            number_of_rooms: numberRooms, // Brand of hte hotel (si aplica)
            number_of_nights: numberOfNights, // Number of nights of booking
            booking_window: bookingWindow, // Booking window of the search check in date
            new_date_time: currentDate, // Current date in MM-DD-YYYY format
            special_offer_code: codpromo, // Promocode (si aplica)
            corporate_group_number: corporateGroupNumber, // Corporate group number entered
            search_options: '', // Points or Accessible Room or Points|Accessible Room
            onsite_click_element: 'Resv:ChooseYourDates:SelectButton'
        });
    }

    _submitInIframe () {
        if (window === window.parent) {
            this._form.addEventListener('submit', (e) => {
                if (typeof utag !== 'undefined') {
                    this._utagSubmitEvent();
                }
                if (this._destinationCode.value === '') {
                    e.preventDefault();
                    if (this._customDestinationList) {
                        this._modalNoDestiny.style.display = 'block';
                    } else {
                        this._destinationName.selectedIndex = this._destinationName.options.length - 1;
                        this._destinationName.dispatchEvent(new Event('change'));
                        this._form.submit();
                    }
                }
            });
        } else { this._form.setAttribute('target', '_top'); }
    }
}
